export const FETCH_LIST_DEPARTMENT_REQUEST = "FETCH_LIST_DEPARTMENT_REQUEST";
export const FETCH_LIST_DEPARTMENT_SUCCESS = "FETCH_LIST_DEPARTMENT_SUCCESS";
export const FETCH_LIST_DEPARTMENT_FAILURE = "FETCH_LIST_DEPARTMENT_FAILURE";


export const FETCH_DEPARTMENT_REQUEST = "FETCH_DEPARTMENT_REQUEST";
export const FETCH_DEPARTMENT_SUCCESS = "FETCH_DEPARTMENT_SUCCESS";
export const FETCH_DEPARTMENT_FAILURE = "FETCH_DEPARTMENT_FAILURE";


export const ADD_DEPARTMENT_REQUEST = "ADD_DEPARTMENT_REQUEST";
export const ADD_DEPARTMENT_SUCCESS = "ADD_DEPARTMENT_SUCCESS";
export const ADD_DEPARTMENT_FAILURE = "ADD_DEPARTMENT_FAILURE";


export const UPDATE_DEPARTMENT_REQUEST = "UPDATE_DEPARTMENT_REQUEST";
export const UPDATE_DEPARTMENT_SUCCESS = "UPDATE_DEPARTMENT_SUCCESS";
export const UPDATE_DEPARTMENT_FAILURE = "UPDATE_DEPARTMENT_FAILURE";


export const DELETE_DEPARTMENT_REQUEST = "DELETE_DEPARTMENT_REQUEST";
export const DELETE_DEPARTMENT_SUCCESS = "DELETE_DEPARTMENT_SUCCESS";
export const DELETE_DEPARTMENT_FAILURE = "DELETE_DEPARTMENT_FAILURE";


export const RESET_CURRENT_DEPARTMENT = "RESET_CURRENT_DEPARTMENT";